import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const UserDashboardAppLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboard" */
      './UserDashboardApp.dynamic'
    ),
  loading: LoadingPageLoadable,
});
